export default {"src":"/org/_next/static/media/banknote.b76d1eb1.svg","height":12,"width":14,"blurWidth":0,"blurHeight":0};